import { appConfig } from "@/lib/appConfig";
import { defaultHttpResHandler } from "@/store/helpers/defaultHttpResHandler";
import { makeGetReq, makePostReq } from "@/store/helpers/request";

export const fetchLesson = async (token, courseId,lessonId) => await defaultHttpResHandler(async () => await makeGetReq(appConfig.domain + '/course/'+courseId+'/lesson/' + lessonId, {token}));

export const savePassedLesson = async (token, data) => await defaultHttpResHandler(async () => await makePostReq(appConfig.domain + '/course/passing', data, {
    token,
    data: true
}));